<template>
  <section class="content">
      <!-- <div class="box box-info"> -->
        <form >
            <website ref="website"/>
            <div class="name">
            <div class="page section-header text-center">
              <h1 >EXCHANGE & CANCELLATIONS</h1>
            </div>
            <div class="page-width">
              <div class="rte"></div>
              <div class="page-width">
                <div class="custom-content"> 
                <div class="custom__item custom__item--1537787486018 one-whole align--center">
                  <div class="medium-up--text-center">

    <h4 class="h4"> How do I Cancel or Exchange?</h4>
    <div class="rte-setting">
<p>
Drop an Email on talk.lilpicks@gmail.com or whatsApp on 9911437000
</p>
 <h4 class="h4"> What items are non-exchangeable?</h4>
You can exchange your items within 15 days of receipt of your shipment.
<p>
* They must be in original condition
* Must be unwashed and unworn
* In the original packaging
* Free gifts or promotional items are non-exchangeable !
</p>

<h4 class="h4"> Are there any charges for exchange?</h4>
<p>
* There are no charges for exchange.
</p>
<h4 class="h4"> How soon will I get my exchange product?</h4>
<p>
Once your return is received and inspected, we will send you an email to notify you that we have received your returned item. We will also notify you of the approval or rejection of your exchange. If you are approved, then your exchange will be processed, and mention your exchange items on mail or whatsApp. We will dispatch your product within 2-3 days.
</p>
    </div>
                  </div>
                </div>

                </div>
              </div>

            </div>
      </div>
      <footerWebsite ref="footerWebsite"/>
</form>
    <!-- </div> -->
  </section>
</template>
<script>
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
export default {
  name: 'exchangeAndCancellations',
  props: ['exchangeAndCancellations'],
  data() {
    return {
      name: '',
      layout: 'grid',
      sortOrder: null,
      sortField: null,
      sortOptions: [
       {label: 'Price High to Low', value: '!price'},
       {label: 'Price Low to High', value: 'price'}
      ],
      englishDateEnabled: true,
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null,
      products: null
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
  components: {
    website,
    footerWebsite
  }
}
</script>
<style scoped  src="@../../../static/css/website.css" >
</style>



// WEBPACK FOOTER //
// exchangeAndCancellations.vue?fd87ec4a